var _rect, _path, _g, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPaymentMethodCartesbancaires(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.20264,
    y: 3.84766,
    width: 21,
    height: 14.3043,
    rx: 2,
    fill: "url(#paint0_linear_19695_104824)",
    stroke: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19695_104824",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 7,
    width: 18,
    height: 8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.26929 7.47583H20.166V14.6667H3.26929V7.47583Z",
    fill: "#FEFEFE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19695_104824)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.67672 10.7672H12.0998C12.0603 9.8953 11.8376 8.99639 11.1619 8.41899C10.3572 7.7312 8.94752 7.47607 7.68794 7.47607C6.37692 7.47607 4.92706 7.7559 4.11802 8.49386C3.42036 9.12955 3.26953 10.1524 3.26953 11.0713C3.26953 12.0339 3.56461 13.1536 4.32144 13.799C5.12623 14.4848 6.43029 14.667 7.68794 14.667C8.90962 14.667 10.233 14.4613 11.0332 13.8098C11.831 13.159 12.1067 12.0629 12.1067 11.0713V11.0667H7.67672V10.7672Z",
    fill: "#FEFEFE"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3826 11.0728V14.5244H18.5284V14.5197C19.4277 14.4748 20.1431 13.7319 20.1431 12.8197C20.1431 11.9072 19.4277 11.1166 18.5284 11.0713V11.0728H12.3826Z",
    fill: "#FEFEFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0363 9.20274C20.0363 8.32268 19.3401 7.62523 18.4629 7.62523C18.4023 7.62523 18.3276 7.6136 18.2689 7.62019H12.3826V10.7864H18.5836C19.3969 10.7163 20.0363 10.0359 20.0363 9.20274Z",
    fill: "#FEFEFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19695_104824",
    x1: 11.7026,
    y1: 3.34766,
    x2: 11.7026,
    y2: 18.6502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#283A7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258576,
    stopColor: "#4790CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742994,
    stopColor: "#4790CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99998,
    stopColor: "#337557"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaymentMethodCartesbancaires);
export default __webpack_public_path__ + "static/media/icon_payment_method_cartesbancaires.6e0273d5669e1df794aa356f8085a506.svg";
export { ForwardRef as ReactComponent };